<template>
	<div class="container" v-loading.fullscreen.lock="fullscreenLoading">
		<cnHeader></cnHeader>
		<div class="page_content">
			
			<!--面包屑与公共提醒-开始-->
			<div class="ext_head">
				<div class="bread_crumb">
					<a href="/cn">首页</a><span class="space">/</span>用户中心<span class="space">/</span>账户登录
				</div>
			</div>
			<!--面包屑与公共提醒-结束-->
			
			<!--页面内容-开始-->
			<div class="create_user_box">
				<!-- <div class="login_icon"></div> -->
				<h1>账户登录</h1>
				<h5>请使用您的电子邮件登录您的帐户。</h5>
				<div class="input_box">
					<div class="item">
						<div class="title">电子邮件</div>
						<div class="e_input">
							<input class="in_txt" v-model="email" ref="email" type="text" maxlength="50" placeholder="请输入电子邮件地址" />
						</div>
					</div>
					<div class="item">
						<div class="title">登录密码</div>
						<div class="e_input">
							<input class="in_txt" v-model="password" ref="password" type="password" maxlength="20" placeholder="请输入登录密码" />
						</div>
					</div>
					<div class="error_text" v-if="errStatus">{{errMessage}}</div>
				</div>
				<div class="btns">					
					<el-button type="primary" :loading="btnLoading" style="width: 100%;" @click="loginCheck()">{{btnTxt}}</el-button>
				</div>
				<div class="space_txt">
					<div class="txt">或在下面创建新帐户</div>
				</div>
				<div class="other_box">
					<div class="pub_btn" @click="toSign()">注册新账户</div>
				</div>
			</div>
			<!--页面内容-结束-->
		</div>
		<cnFooter></cnFooter>
	</div>
</template>


<script>
	import {
		userLogin,
	} from '@/api/index.js'
	import cnHeader from '@/components/cn_header.vue'
	import cnFooter from '@/components/cn_footer.vue'
	export default {
		name: 'CN_UserLogin',
		components: {
			cnHeader,
			cnFooter,
		},
		data() {
			return {
				fullscreenLoading: false, //loading状态
				email: '',
				password: '',
				terminal: 'pc',
				errStatus: false,	//错误状态
				errMessage: '',	//错误提示
				returnUrl: '',	//登录后跳转地址
				timer: null,
				
				btnLoading: false,
				btnTxt: '登录',
			}
		},
		created() {
			if(this.$route.query.ReturnUrl !=undefined)
			{
				this.returnUrl = decodeURIComponent(this.$route.query.ReturnUrl)
			}
		},
		beforeDestroy() {
			clearTimeout(this.timer)
		},
		methods: {
			//登录
			async loginCheck()
			{
				if(this.btnLoading)
				{
					return
				}
				
				if(this.email =='')
				{
					this.errStatus = true
					this.errMessage = '请输入电子邮件地址'
					this.$refs.email.focus()
					return
				}
				const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
				if (!emailPattern.test(this.email)) {
					this.errStatus = true
					this.errMessage = '电子邮件格式错误'
					this.$refs.email.focus()
					return
				}
					  
				if(this.password =='')
				{
					this.errStatus = true
					this.errMessage = '请输入登录密码'
					this.$refs.password.focus()
					return
				}
				if(this.password.length < 6)
				{
					this.errStatus = true
					this.errMessage = '密码长度不得小于6个字符'
					this.$refs.password.focus()
					return
				}
				
				this.errStatus = false
				this.errMessage = ''
				
				this.btnLoading = true
				this.btnTxt = "登录中，请稍候..."
				this.fullscreenLoading = true
				
				let params={
					Email: this.email,
					Password: this.password,
					Terminal: this.terminal
				}
				const { data: res } = await userLogin(params)
				if (res.errcode === 0) {
					this.$storeage.set('token',res.data.Token)
					this.$storeage.set('expire',res.data.ExpireTime)
					
					this.$message.success('登录成功');
					this.timer = setTimeout(() => {
						if(this.returnUrl !='')
						{
							window.location.href = this.returnUrl
						}
						else
						{
							this.$router.push({
								path: '/cn/user/index'
							})
						}
					}, 500)
				} else {
					this.btnLoading = false
					this.btnTxt = "登录"
					this.fullscreenLoading = false
					this.$message.error(res.errmsg);
				}
			},
			// 去注册
			toSign()
			{
				this.$router.push({
					path: '/cn/user/sign'
				})
			}
		}
	}
</script>

<style lang="less" scoped>
	.container {
		width: 100%;
		box-sizing: border-box;

		.el-button--primary {
			font-family: "PingFang SC", sans-serif, Helvetica, Arial;
			font-size: 15px;
			font-weight: 400;
			height: 42px;
			border: 0;
			border-radius: 8px;
			-webkit-transition: all .3s ease;
		}
		.el-button--primary:focus {
			background-color: #008768;
		}
		.el-button--primary:hover {
			background-color: #000;
		}
	}
</style>